// Fonction pour ajouter un produit au panier via l'API Shopify avec AJAX
function ajouterProduitAuPanier(produitID) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: [
        {
          quantity: 1,
          id: produitID,
        },
      ],
    },
    dataType: 'json',
    success: function() {
      // Gérer la réponse de l'ajout au panier (rafraîchissement de la page, message utilisateur, etc.)
      console.log('Produit ajouté au panier !');
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error('Erreur lors de l\'ajout au panier :', errorThrown);
    }
  });
}

// Fonction pour vérifier le montant du panier et ajouter les produits
function verifierMontantPanier() {
  // Récupérer le montant total du panier depuis Shopify
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const montantTotal = data.total_price / 100; // Convertir le montant en euros (si la devise est différente)
      
      // Vérifier le montant du panier et ajouter les produits en conséquence
      if (montantTotal > 1) {
        // Ajouter la carte de vœux au panier
        ajouterProduitAuPanier('8814483603779');
      }
      if (montantTotal > 25) {
        // Ajouter le sapin de Noël pour voiture au panier
        ajouterProduitAuPanier('8714488840515');
      }
    })
    .catch(error => {
      console.error('Erreur lors de la récupération du panier :', error);
    });
}

// Appeler la fonction au chargement de la page
verifierMontantPanier();
